
/**
 * La struttura ad albero delle COLONNE e RIGHE
 */
export interface Item {
	/**il valore preso dai "data" */
	value: string
	/** se è espanso (false) o collassato (true) */
	collapsed: boolean
	/** struttura ad albero */
	children?: Item[]
	/** Gli indici dei DATA che questo Item gestisce */
	indexes?: number[]

	/** totali dei valori contenuti */
	totals?: number[]

	/** indica a che profondità dell'albero sta puo' essere messo in corrispondenza con la Property */
	depth?: number
	/** posizione corrente nella lista visibile */
	count?: number
}

export enum PROPERTY_TYPE {
	STRING,
	NUMBER,
	DATE,
}

/**
 * proprietà dei dati da usare e come deve essere utilizzata
 */
export interface Property {
	// "name" e "label" sono usati come id per il drag&drop
	/** nome presente nella fonte dati */
	name: string
	/** nome visualizzabile */
	label?: string

	/** utile descrizion della PROPERTY */
	description?: string

	/** tipo di dato gestito */
	type?: PROPERTY_TYPE
	/** [II][NON SERVE PIU] se è effettivamente visibile o no in GRID */
	visible?: boolean
	/** indica che deve iniziare la visualizzazione da "collassato" */
	startCollapsed?: boolean
	
	/** css Item che implementa questa Property */
	style?: React.CSSProperties
	/** colore utilizzato per rappresentare questa PROP */
	color?: string

	/** funzione di raggruppamento */
	fnGroup?: (value1: any, value2: any) => any
	/** il sorting da effettuare */
	sort?: (item1: Item, item2: Item) => number
	/** restituisce il valore visualizzabile */
	render?: (value: any) => string

	/** valore per l'export CSV */
	renderCsv? : (value: any) => string

	/** indica se è solo per la generazione CSV */
	onlyForCSV?: boolean

	/** filtra i valori a soli questi */
	valueFilter?: any[]
}

/**
 * Opzioni di visualizzazione della GRID
 */
export interface GridOptions {
	cell: {
		width: number,
		height: number,
	},
	margin: {
		horiz: number,
		vert: number,
	},
	effect?: "none" | "temp",
	minimap?: boolean
}

/**
 * Statistiche di una proprietà
 */
export interface GridStats {
	/** la somma di tutti i valori */
	total: number
	/** la media di tutti i valori */
	average: number
	/** il valore massimo */
	max: number
	/** il valore minimo */
	min: number
}

/**
 * Linformazione dello scrolling
 */
export interface ScrollData {

	rowTopNM: number
	rowDownNM: number
	rowVisibleNM: number
	colLeftNM: number
	colRightNM: number
	colVisibleNM: number

	// CON I MARGINI
	//** numero di righe sopra l'area visibile*/
	rowTop: number
	/** numero di righe sotto l'area visibile */
	rowDown: number
	/** numero di righe visibili */
	rowVisible: number
	/** numero di righe totali */
	rowTot: number
	/** numero di colonne a sinistra dell'area visibile */
	colLeft: number
	/** numero di colonne a destra dell'area visibile */
	colRight: number
	/** numero di colonne visibili */
	colVisible: number
	/** numero di colonne totali */
	colTot: number
}

/**
 * La descrizione di una funzione per ordinamento o gruppo
 */
export type SortFunctionType = {
	id: number;
	label: string;
	fn: (val1: any, val2: any) => number;
};
